import { useMemo } from "react"
import { useTheme } from "@mui/material"

import type { SxProps } from "@mui/material"

import { AngleViewLayout } from "./AngleViewLayout"

interface PowerlineAngleViewProps {
  src: string
  value: number
  viewKey: "first" | "second"
  displayName: string
  rowHeight: number
  alt?: string
}

export const PowerlineAngleView = ({
  src,
  value,
  viewKey,
  displayName,
  rowHeight,
  alt,
}: PowerlineAngleViewProps) => {
  const theme = useTheme()
  const isFirstView = viewKey === "first"

  const imgBoxStyles = useMemo<SxProps>(
    () => ({
      height: `${rowHeight * 4}px`,
      pb: { xs: "1.5rem", sm: 0 },
      [theme.breakpoints.up("sm")]: {
        height: `${rowHeight * 3.5}px`,
      },
    }),
    [rowHeight, theme.breakpoints],
  )

  const imgStyles = useMemo<SxProps>(() => {
    const rotate = `rotate(${-value}deg)`
    const absValue = Math.abs(value)
    return isFirstView
      ? {
          transform: rotate,
          transformOrigin: "50% 20%",
          translate: `${absValue > 90 ? "0 12rem" : "0"}`,
          height: "90%",
          margin: "3.5rem 0",
        }
      : {
          transform: rotate,
          transformOrigin: "50% 30%",
          translate: `${absValue > 90 ? "0 10rem" : "0"}`,
          height: "90%",
          margin: "3rem 0",
        }
  }, [value, isFirstView])

  const valueBoxStyles = useMemo<SxProps>(
    () => ({
      overflow: "hidden",
      position: "absolute",
      bottom: "0.5rem",
      width: "100%",
    }),
    [],
  )

  return (
    <AngleViewLayout
      src={src}
      viewKey={viewKey}
      displayName={displayName}
      alt={alt}
      imgBoxStyles={imgBoxStyles}
      imgStyles={imgStyles}
      valueBoxStyles={valueBoxStyles}
    />
  )
}
